import { useCurrentUser } from 'hooks/auth';

export const useCurrentTalentRegion = () => {
  const { getData } = useCurrentUser();
  const region = getData()?.data?.currentTalent?.region;

  return region;
};

export const useIsUsCurrentTalent = () => {
  const region = useCurrentTalentRegion();
  return region === 'US';
};
